module.exports = __webpack_public_path__ + "img/signup-page-image.a0dfdf17.png";